<template>
<div>
  <div class="loan_v1_wrapper">
        <div class="page page1">
          <div class="header">
            <h1>和潤企業分期進件首頁</h1>
            <div class="barcode"><img :src="barcodeImage"></div>
            <span class="nb">A001</span>
          </div><!--header-->
          <div class="area1">
            <table class="table1">
              <tr>
                <th width="100px" class="th1">營業處</th>
                <td>中區&nbsp;通路行銷處</td>
              </tr>
              <tr>
                <th class="th2">車主姓名</th>
                <td>{{editedItem.customer.name}}</td>
              </tr>
            </table><!--table1-->
            <table class="table2">
              <tr>
                <th width="100px" class="th1">進件來源</th>
                <td>
                  <div class="con1">
                    <span class="checkbox"><input type="checkbox" checked="" disabled=""></span>OA
                    <span class="checkbox" style="margin-left:29px;"><input type="checkbox" disabled=""></span>AO
                    <span class="checkbox" style="margin-left:38px;"><input type="checkbox" disabled=""></span>電銷課
                  </div>
                </td>
              </tr>
              <tr>
                <th class="th2">資料袋別</th>
                <td>
                  <div class="con2">
                    <span class="checkbox"><input type="checkbox"  disabled=""></span>和潤
                    <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled="" checked=""></span>AR
                    <span class="checkbox" style="margin-left:13px;"><input type="checkbox" disabled=""></span>中古原融
                    <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>機車原融<br/>
                    <span class="checkbox"><input type="checkbox"  disabled=""></span>遠銀
                    <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled="" ></span>中信
                    <span class="checkbox" style="margin-left:3px;"><input type="checkbox" disabled=""></span>台新
                    <span class="checkbox" style="margin-left:35px;"><input type="checkbox" disabled=""></span>機車自承
                  </div>
                </td>
              </tr>
            </table><!--table2-->
          </div><!--area1-->
          <div class="area2">
            <div class="title1">車商資料</div>
            <table class="table3">
              <tr>
                <th width="100px" class="th1">經銷商代號/ID</th>
                <td width="217px"></td>
                <th width="100px" class="th2">經銷商名稱</th>
                <td>個人</td>
              </tr>
              <tr>
                <th class="th3">營業所代號/ID<br/><span>(撥款對象)</span></th>
                <td></td>
                <th class="th4">營業所名稱<br/><span>(撥款對象)</span></th>
                <td>{{editedItem.customer.name}}</td>
              </tr>
              <tr>
                <th class="th5">車行人員ID<br/><span>(撥款對象)</span></th>
                <td></td>
                <th class="th6">車行人員姓名<br/><span>(撥款對象)</span></th>
                <td>雲鼎電通有限公司；據點40</td>
              </tr>
            </table><!--table3-->
          </div><!--area2-->
          <div class="area3">
            <div class="title1">承辦單位資料</div>
            <table class="table4">
              <tr>
                <th width="100px" class="th1">承辦單位ID</th>
                <td width="217px"></td>
                <th width="100px" class="th2">承辦單位名稱</th>
                <td>雲鼎電通有限公司；據點40</td>
              </tr>
              <tr>
                <th class="th3">承辦人ID</th>
                <td></td>
                <th class="th4">承辦人姓名</th>
                <td>{{editedItem.contactName}}</td>
              </tr>
              <tr>
                <th class="th5">進件業務ID</th>
                <td></td>
                <th class="th6">進件業務姓名</th>
                <td></td>
              </tr>
              <tr>
                <th class="th7">聯絡電話</th>
                <td></td>
                <th class="th8">手機號碼</th>
                <td></td>
              </tr>
              <tr>
                <th class="th9">對保人員ID</th>
                <td></td>
                <th class="th10">對保人員姓名</th>
                <td>{{editedItem.insureAgent}}</td>
              </tr>
              <tr class="trB">
                <th class="th11">引擎號碼</th>
                <td></td>
                <th class="th12">車身號碼</th>
                <td>{{editedItem.laonhfcInfo.engineId}}</td>
              </tr>
            </table><!--table4-->
            <table class="table5">
              <tr>
                <th width="150px">HOT認證號碼</th>
                <td></td>
              </tr>
            </table><!--table5-->
          </div><!--area3-->
          <div class="area4Left">
            <div class="title1">
              <div class="con3">
                <span class="checkbox"><input type="checkbox" checked="" disabled=""></span>&nbsp;新&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;車
              </div>
            </div><!--title1-->
            <table class="table6">
              <tr>
                <td colspan="2">
                  廠牌：
                  <div class="con4">
                    <span class="checkbox"><input type="checkbox" disabled=""></span>T<span class="checkbox"><input type="checkbox" disabled=""></span>L<span class="checkbox"><input type="checkbox" disabled=""></span>他牌<span class="checkbox"><input type="checkbox" disabled="" checked="" ></span>機車
                  </div>
                </td>
              </tr>
              <tr>
                <th rowspan="3">他牌</th>
                <td>
                  <div class="con5">
                    <span class="checkbox"><input type="checkbox" checked="" disabled=""></span>一般車<span class="checkbox"><input type="checkbox" disabled=""></span>營業車
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="con6">
                    <span class="checkbox"><input type="checkbox" disabled=""></span>補貼<span class="checkbox"><input type="checkbox" disabled=""></span>平衡<span class="checkbox"><input type="checkbox" disabled=""></span>退佣
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="con7">
                    <span class="checkbox"><input type="checkbox" disabled="" checked></span>其他：<div class="con7-1"></div>
                  </div>
                </td>
              </tr>
            </table><!--table6-->
            <table class="table7">
              <tr>
                <th rowspan="3">本牌</th>
                <td>
                  <div class="con8">
                    <span class="checkbox"><input type="checkbox" checked="" disabled=""></span>營業車<span class="checkbox"><input type="checkbox" disabled=""></span>一般車
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="con9">
                    <span class="checkbox"><input type="checkbox" disabled=""></span>補貼<span class="checkbox"><input type="checkbox" disabled=""></span>平衡<span class="checkbox"><input type="checkbox" disabled=""></span>退佣
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="con10">
                    <span class="checkbox"><input type="checkbox" disabled=""></span>限制<span class="checkbox"><input type="checkbox" disabled=""></span>無限
                  </div>
                  <div class="con11">
                    <span class="checkbox"><input type="checkbox" disabled=""></span>Toyota0%：<div class="con11-1"></div>
                  </div>
                  <div class="con12">
                    <span class="checkbox"><input type="checkbox" disabled=""></span>Lexus&nbsp;0%：<div class="con12-1"></div>
                  </div>
                  <div class="con13">
                    <span class="checkbox"><input type="checkbox" disabled=""></span>其他：<div class="con13-1"></div>
                  </div>
                </td>
              </tr>
            </table><!--table7-->
          </div><!--area4Left-->
          <div class="area4Right">
            <div class="title1">
              <div class="con14">
                <span class="checkbox"><input type="checkbox" checked="" disabled=""></span>中古
                <span class="checkbox" style="margin-left:14px;"><input type="checkbox" :checked="itemInfo.vendor.productId === '0' || !itemInfo.vendor.productId" disabled=""></span>原融
                <span class="checkbox" style="margin-left:13px;"><input type="checkbox" :checked="itemInfo.vendor.productId === '1'" disabled=""></span>借新還舊
                <span class="checkbox" style="margin-left:7px;"><input type="checkbox" :checked="itemInfo.vendor.productId === '2'" disabled=""></span>他行代償
              </div>
            </div><!--title1-->
            <div class="box1">
              <div class="con15">
                <span class="checkbox"><input type="checkbox" checked="" disabled=""></span>營業車<span class="checkbox" style="margin-left:3px;"><input type="checkbox" disabled=""></span>一般車<span class="checkbox" style="margin-left:17px;"><input type="checkbox" disabled=""></span>HOT<span class="checkbox" style="margin-left:16px;"><input type="checkbox" disabled=""></span>機車
              </div>
            </div><!--box1-->
            <div class="box2">
              <div class="con16">
                <span class="checkbox"><input type="checkbox" checked="" disabled=""></span>超U<br/>
                <span class="checkbox"><input type="checkbox" disabled=""></span>U3<br/>
                <span class="checkbox"><input type="checkbox" disabled=""></span>U2<br/>
                <span class="checkbox"><input type="checkbox" disabled=""></span>U1<br/>
                <span class="checkbox"><input type="checkbox" disabled=""></span>普貸<br/>
                <span class="checkbox"><input type="checkbox" disabled=""></span>小額貸
              </div>
            </div><!--box2-->
            <div class="box3">
              <div class="con17">
                <span class="checkbox"><input type="checkbox" checked="" disabled=""></span>Normal<span class="s1">(標準利率)</span><br/>
                <span class="checkbox"><input type="checkbox" disabled=""></span>Plus1<span class="s2">(標準利率起佣降0.25%)</span><br/>
                <span class="checkbox"><input type="checkbox" disabled=""></span>Plus2<span class="s3">(標準利率起佣降0.5%)</span>
              </div>
            </div><!--box3-->
            <div class="clear"></div>
            <div class="box4">
              <div class="con18">
                <span class="checkbox"><input type="checkbox" checked="" disabled=""></span>其他:<span class="othersCon">機車OA機車OA機車OA</span>
              </div>
              <div class="con19">
                <span class="checkbox"><input type="checkbox" disabled=""></span>靠行件<br/>
                <span class="checkbox"><input type="checkbox" disabled=""></span>高成數
              </div>
            </div><!--box4-->
            <div class="box5">
              <div class="con20">
                廠牌：
                <span class="checkbox" style="margin-left:-5px;"><input type="checkbox" disabled=""></span>T<span class="checkbox" style="margin-left:63px;"><input type="checkbox" disabled=""></span>L<span class="checkbox" style="margin-left:63px;"><input type="checkbox" disabled=""></span>他牌<br/>
                <span class="checkbox" style="margin-left:57px;"><input type="checkbox" disabled=""></span>體系內中古車<span class="checkbox" style="margin-left:69px;"><input type="checkbox" disabled=""></span>Lexux&nbsp;CPO
              </div>
            </div><!--box5-->
            <div class="box6">
              <div class="con21">
                <span class="checkbox"><input type="checkbox" disabled=""></span>補貼<span class="checkbox" style="margin-left:64px;"><input type="checkbox" disabled=""></span>平衡<span class="checkbox" style="margin-left:44px;"><input type="checkbox" disabled=""></span>退佣
              </div>
            </div><!--box6-->
          </div><!--area4Right-->
          <div class="clear"></div>
          <div class="y1">所附文件&nbsp;&nbsp;共<span class="pg">5</span>張</div>
          <div class="y2">案件核准通知書回傳號碼：1234567890</div>
          <div class="ps">
            ※進件必要文件：<u>申請書</u>、<u>和潤分期申請資格表</u>、<u>ID(營登證)影本</u>、<u>行照(牌登書)</u>影本<br/>
            ※進件車商/營業所/車行/車行人員名稱及ID、統編為必要欄位請務必填寫以利撥款作業確認<br/>
            FR-BA-032-012<span class="nb">106.03 版</span>
          </div>
        </div><!--page1-->

    </div><!--wrapper-->
</div>
  
  <!--wrapper-->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { sortApplicationItem } from '@/pages/utils/tool';

export default {
  name: "loanhfcViewPrintV1",
  props: {
    item: Object
  },
  data() {
    return {
      barcodeImage: require("../../assets/images/barcode.jpg"),
      createDate: "",
      itemInfo:null,
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    editedItem() {
      this.itemInfo = sortApplicationItem(this.item);
      return this.itemInfo;
    }
  },
  methods: {
    ...mapActions(["fetchFinanceCreditInfo"]),
    signImageSrc(itemPath) {
      let source = "";
      if (itemPath === "signImage1") {
        if (this.editedItem.signImage1) {
          source = this.editedItem.laonhfcInfo.signImage1;
        } else if (this.editedItem.laonhfcInfo.signimage1Url) {
          source = this.editedItem.laonhfcInfo.signimage1Url;
        }
      } else if (itemPath === "signImage2") {
        if (this.editedItem.laonhfcInfo.signImage2) {
          source = this.editedItem.laonhfcInfo.signImage2;
        } else if (this.editedItem.laonhfcInfo.signimage2Url) {
          source = this.editedItem.laonhfcInfo.signimage2Url;
        }
      } else if (itemPath === "signImage3") {
        if (this.editedItem.signImage3) {
          source = this.editedItem.laonhfcInfo.signImage3;
        } else if (this.editedItem.laonhfcInfo.signimage3Url) {
          source = this.editedItem.laonhfcInfo.signimage3Url;
        }
      }
      console.log(` productId === ${this.editedItem.productId}`);
      return source;
    },
  }
};
</script>

<style scoped src="../../assets/css/loanhfc_print_v1.css">

</style>



// WEBPACK FOOTER //
// src/pages/web/loanhfcViewPrintV1.vue